
define(function (require, exports) {
    'use strict';

     /**
     * @type {ng.IAngularStatic}
     */
    var _ = require('lodash');


    // @ngInject
    exports.whyModal = function () {

        return {
            restrict: 'E',
            scope: {
                modalActive: '=',
                closeModal: '=',
                message: '@',
                footerMessage: '@'
            },
            template: `
            <div class="popUp" ng-show="modalActive">
                <div class="modal-why-dialog modal-lg">
                    <div class="modal-why-header">
                        <div class="error-title"> Error </div>
                        <hr class="why-modal">
                    </div>
                    <div class="modal-wrapper">
                        <p>{{message}}</p>
                        <p> {{ footerMessage }} </p>
                        <button class="btn btn-default closing-modal-btn" ng-click="modalActive = false"> Close </button>
                    </div>
                </div>
            </div>
            `
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/why-modal.js